import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'; 
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CertificationService } from './certification.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { FacilityService } from 'src/app/services/facility.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.css']
})
export class CertificationComponent implements OnInit {
  selectedFiles: FileList;
  censusFile:any; 
  @ViewChild('file_uploader') file_uploader: ElementRef;
  currentUser:any
  selectedXMLFiles = [];
  otherFiles = [];
  progressInfos: any[] = [];
  message: string[] = [];

  showButtons = true;
  extractButton = true;
  haveXMLs = false;ks
  fileInfos?: Observable<any>;
  havePatients = false;
  havecensusPatients = false;
  haveNotes = false;
  facilityPatients: any;
  censusPatients: any;
  totalNotes: any;
  mips;
  addMoreData = false;
  generateReport = false;
  loading = true;
  selectedMip;
  facilities: any = [];
  providers: any = [];
  census: any = [];
  selectedFacility: any;
  selectedCensus: any;
  selectedProvider: any;
  censusLength = 0;
  insertedPatientsCount = 0;
  duplicatedPatientsCount = 0;
  showStatus = false;
  // extractedInfo = {

  // }
  
  constructor(
    public dialogRef: MatDialogRef<CertificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private authService: AuthService,
    private certificationService: CertificationService,
    private facilityService: FacilityService,
    private dashboardService: DashboardService
  ) { 
    this.currentUser = this.authService.currentUser;
  }

  async ngOnInit() {
    this.loading = true;
    await this.getProviders()
    // await this.getFacilities();
    // let result:any = await this.certificationService.checkData().toPromise();
    // if(result.status == 200){
    //   console.log('We have XMLs-----------')
    //   this.facilityPatients = result.data;
    //   this.havePatients = result.data > 0 ? true: false;
    //   if(result.data > 0 ){
    //     this.havePatients = true
    //     console.log('this.havePatients: ', this.havePatients)
    //     console.log('add more data: ', this.addMoreData)
    //     await this.getMIPs();
    //   }
    //   else
    //     this.havePatients = false;
    // }
  }

  async getProviders(){
    let res: any = await lastValueFrom(this.dashboardService.getP2PRelation(null, this.currentUser._id)) as any;
    if(res.status == 200){
      this.providers = res.data.assoc_provider_id;
      this.providers = [this.currentUser].concat(this.providers)
      console.log("this.providers:----------- ", this.providers)
      this.selectedProvider = this.providers[0]._id;
      this.providers = this.providers.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
      await this.getFacilities(this.selectedProvider) 
    }
  }
  async getMIPs(){
    let res:any = await this.certificationService.getMIPs().toPromise();
    if(res.status == 200){
      this.mips = res.data;
    }
    this.loading = false;
  }
  async getFacilities(provider){
    this.showStatus = false;
    let facResult: any = await lastValueFrom(this.facilityService.getMyFacilities(provider) as any)
    if(facResult.status ==  200){
      if(facResult.data?.array && facResult.data?.array.length > 0){
        this.facilities = facResult.data.array;
        this.selectedFacility  = this.facilities[0]._id;
        await this.checkCensus();
        // await this.checkData()
      }
      else{
        this.toastr.info('There is no associated facility.')
      } 
    }
    else{
      this.toastr.error('Something went wrong')
    }
  }
  async checkCensus(){
    let res: any = await lastValueFrom( this.certificationService.checkCensus(this.selectedFacility, this.selectedProvider) as any)
    if(res.status ==  200){
      if(res.censusLength > 0){
        this.censusLength = res.censusLength; 
        this.census = res.census;
        this.selectedCensus  = this.census[0]._id;
        await this.checkData()
      }
      else{
        this.toastr.info('There is no census cretaed.')
      } 
    }
    else{
      this.toastr.error('Something went wrong')
    }
  }

  async checkData(){
    let result:any = await lastValueFrom(this.certificationService.checkData(this.selectedFacility, this.selectedProvider, this.selectedCensus) as any);
    if(result.status == 200){
      // console.log('We have XMLs-----------')totalNotes
      this.facilityPatients = result.failityPatientsLength
      this.censusPatients = result.censusPatientsLength;
      this.totalNotes = result.notesLength;
      this.havecensusPatients = result.failityPatientsLength > 0 ? true: false;
      this.havePatients = result.censusPatientsLength > 0 ? true: false;
      this.haveNotes = result.notesLength > 0 ? true: false;
      this.addMoreData = false; 
      if(this.havePatients && this.haveNotes){ 
      // if(this.havePatients){ 
        await this.getMIPs();
      } 
    }
    this.loading = false
  }
  async providerChange(provider){
    this.selectedProvider = provider.value;
    this.getFacilities(this.selectedProvider)
  }
  facilityChange(event) {   
    this.selectedFacility = event.value;
    this.loading = true;
    this.checkData()
  }
  censusChange(event) {   
    this.selectedFacility = event.value;
    this.loading = true;
    this.checkData()
  }
  
  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
  
    if (file) {
      this.certificationService.uploadFilesForCertification(file, this.selectedFacility, this.selectedProvider, this.selectedCensus).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            const msg = 'Uploaded successfully: ' + file.name;
            this.message.push(msg);
            // this.fileInfos = this.certificationService.getFiles();
          }
        },
        (err: any) => {
          this.progressInfos[idx].value = 0;
          const msg = 'Could not upload: ' + file.name;
          this.message.push(msg);
          // this.fileInfos = this.certificationService.getFiles();
        },
        () => {
          console.log("=================================")
          if(this.message?.length == this.selectedXMLFiles.length){
            let extractPatient = this.extractDataClicked();
          }
        }
        );
    } 
  }

  async generateReportClicked(){
    console.log('generate report clicked: ', this.selectedMip)
    let response:any = await lastValueFrom(this.certificationService.generateReport(this.selectedFacility, this.selectedProvider, this.selectedCensus, this.selectedMip) as any)
    
    this.dialogRef.close();
  }
  selectFiles(event) { 
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        if(this.selectedFiles[i].name?.includes('.xml')){
          this.selectedXMLFiles.push(this.selectedFiles[i])
        }
        else{
          this.otherFiles.push(this.selectedFiles[i])
        } 
      }
    }
    // console.log("this.selectedXMLFiles : ", this.selectedXMLFiles)
    // console.log("this.otherFiles : ", this.otherFiles)
  }
  uploadClicked(){
    if (this.selectedXMLFiles) {
      for (let i = 0; i < this.selectedXMLFiles.length; i++) {
        this.upload(i, this.selectedXMLFiles[i]);
      }
    }
    this.showButtons = false;
  }
 
  cancelClicked(){
    this.dialogRef.close();
  }
  getFolderInfo(){
    // console.log("File Name: ", this.selectedFiles)
    if(this.selectedFiles){
      // if(this.selectedXMLFiles.length == 1){
      //   return `Uploaded folder contains one file named: ${this.selectedFiles[0].name}`;
      // }
      // else if(this.selectedFiles.length > 0){
      //   // return this.selectedFiles[0].name + ' +' + (Number(this.selectedFiles.length)-1) + ' more' ; 
      // }
      return `Uploaded folder contains ${this.selectedFiles.length} file/s in total`;
    }
    else{ 
      // return "No files selected yet."
      return "";
    }
  }

  async extractDataClicked(){
    console.log('extractDataClicked ---------');
    let infoToast =  this.toastr.info('Extracting Patients info from XMLs...', 'Please wait', {
      disableTimeOut: true,
    })
    this.extractButton = false;
    let res:any = await lastValueFrom(this.certificationService.extractData(this.selectedCensus, this.selectedProvider, this.selectedFacility) as any)
    if(res.status == 200){
      this.insertedPatientsCount = res.insertedPatientsCount
      this.duplicatedPatientsCount = res.duplicatedPatientsCount
      this.showStatus = true;
      this.generateReport = false;
      this.addMoreData = false; 
      this.toastr.clear(infoToast.toastId)
      // this.extractedInfo = res
      // console.log('Information extracted: ', res)
      // this.toastr.info(
      //   // `Total Files: ${this.selectedFiles.length}`,
      //   // `XML Files: ${this.selectedXMLFiles.length}`,
      //   `Patients Added: ${res.insertedPatientsCount}`,
      //   `Patients Updated: ${res.duplicatedPatientsCount}`,
      // )
      // this.dialogRef.close();
    }

  }

  getXMLFilesInfo(){
    if(this.selectedXMLFiles){
      if(this.selectedXMLFiles.length == 1){
        return `Uploaded folder contains one XML file named: ${this.selectedXMLFiles[0].name}`;
      }
      else if(this.selectedXMLFiles.length > 1){
        return `Uploaded folder contains ${this.selectedXMLFiles.length} XML file/s`; 
      }
    }
  }
  getOtherFilesInfo(){
    if(this.otherFiles){
      if(this.otherFiles.length == 1){
        return `Uploaded folder contains one non-XML file named: ${this.otherFiles[0].name}`;
      }
      else if(this.otherFiles.length > 1){
        return `Uploaded folder contains ${this.otherFiles.length} non-XML file/s`; 
      }
    }
  }

}
